// extracted by css-extract-rspack-plugin
export default {"container":"RightSection-module__container","subSection":"RightSection-module__subSection"};